{
  "AUTOMATION": {
    "HEADER": "Otomatisasi",
    "DESCRIPTION": "Automation can replace and streamline existing processes that require manual effort, such as adding labels and assigning conversations to the most suitable agent. This allows the team to focus on their strengths while reducing time spent on routine tasks.",
    "LEARN_MORE": "Learn more about automation",
    "COUNT": "{n} automation | {n} automations",
    "HEADER_BTN_TXT": "Create Automation",
    "LOADING": "Mengambil aturan otomatisasi",
    "SEARCH_PLACEHOLDER": "Search automation rules...",
    "NO_RESULTS": "No automation rules found matching your search",
    "ADD": {
      "TITLE": "Tambah Aturan Otomatisasi",
      "SUBMIT": "Buat",
      "CANCEL_BUTTON_TEXT": "Batalkan",
      "FORM": {
        "NAME": {
          "LABEL": "Nama Aturan",
          "PLACEHOLDER": "Masukkan nama aturan",
          "ERROR": "Nama dibutuhkan"
        },
        "DESC": {
          "LABEL": "Deskripsi",
          "PLACEHOLDER": "Masukkan deskripsi aturan",
          "ERROR": "Deskripsi dibutuhkan"
        },
        "EVENT": {
          "LABEL": "Peristiwa",
          "PLACEHOLDER": "Silakan pilih salah satu",
          "ERROR": "Peristiwa dibutuhkan"
        },
        "CONDITIONS": {
          "LABEL": "Kondisi"
        },
        "ACTIONS": {
          "LABEL": "Aksi"
        }
      },
      "CONDITION_BUTTON_LABEL": "Tambah Kondisi",
      "ACTION_BUTTON_LABEL": "Tambah Aksi",
      "API": {
        "SUCCESS_MESSAGE": "Aturan otomatisasi berhasil ditambahkan",
        "ERROR_MESSAGE": "Tidak dapat membuat aturan otomatisasi, Harap coba lagi nanti"
      }
    },
    "LIST": {
      "TABLE_HEADER": {
        "NAME": "Nama",
        "ACTIVE": "Aktif",
        "CREATED_ON": "Dibuat pada",
        "ACTIONS": "Aksi"
      },
      "404": "Tidak ada aturan otomatisasi ditemukan"
    },
    "DELETE": {
      "TITLE": "Hapus Aturan Otomatisasi",
      "SUBMIT": "Hapus",
      "CANCEL_BUTTON_TEXT": "Batalkan",
      "CONFIRM": {
        "TITLE": "Konfirmasi Penghapusan",
        "MESSAGE": "Apakah Anda yakin ingin menghapus ",
        "YES": "Ya, Hapus ",
        "NO": "Tidak, Simpan "
      },
      "API": {
        "SUCCESS_MESSAGE": "Aturan otomatisasi berhasil dihapus",
        "ERROR_MESSAGE": "Tidak dapat menghapus aturan otomatisasi, Harap coba lagi nanti"
      }
    },
    "EDIT": {
      "TITLE": "Edit Aturan Otomatisasi",
      "SUBMIT": "Perbarui",
      "CANCEL_BUTTON_TEXT": "Batalkan",
      "API": {
        "SUCCESS_MESSAGE": "Aturan otomatisasi berhasil diperbarui",
        "ERROR_MESSAGE": "Tidak dapat memperbarui aturan otomatisasi, Harap coba lagi nanti"
      }
    },
    "CLONE": {
      "TOOLTIP": "Klon",
      "API": {
        "SUCCESS_MESSAGE": "Otomatisasi berhasil dikloning",
        "ERROR_MESSAGE": "Tidak dapat mengkloning aturan otomatisasi, Harap coba lagi nanti"
      }
    },
    "FORM": {
      "EDIT": "Edit",
      "CREATE": "Buat",
      "DELETE": "Hapus",
      "CANCEL": "Batalkan",
      "RESET_MESSAGE": "Mengubah jenis peristiwa akan mengatur ulang kondisi dan peristiwa yang Anda tambahkan di bawah"
    },
    "CONDITION": {
      "DELETE_MESSAGE": "Anda harus memiliki setidaknya satu kondisi untuk disimpan",
      "CONTACT_CUSTOM_ATTR_LABEL": "Atribut Kustom Kontak",
      "CONVERSATION_CUSTOM_ATTR_LABEL": "Atribut Kustom Percakapan"
    },
    "ACTION": {
      "DELETE_MESSAGE": "Anda harus memiliki setidaknya satu aksi untuk disimpan",
      "TEAM_MESSAGE_INPUT_PLACEHOLDER": "Masukkan pesan Anda di sini",
      "TEAM_DROPDOWN_PLACEHOLDER": "Pilih tim",
      "EMAIL_INPUT_PLACEHOLDER": "Enter email",
      "URL_INPUT_PLACEHOLDER": "Enter URL"
    },
    "TOGGLE": {
      "ACTIVATION_TITLE": "Aktifkan Aturan Otomatisasi",
      "DEACTIVATION_TITLE": "Nonaktifkan Aturan Otomatisasi",
      "ACTIVATION_DESCRIPTION": "Tindakan ini akan mengaktifkan aturan otomatisasi '{automationName}'. Apakah Anda yakin ingin melanjutkan?",
      "DEACTIVATION_DESCRIPTION": "Tindakan ini akan menonaktifkan aturan otomatisasi '{automationName}'. Apakah Anda yakin ingin melanjutkan?",
      "ACTIVATION_SUCCESFUL": "Aturan Otomatisasi Berhasil Diaktifkan",
      "DEACTIVATION_SUCCESFUL": "Aturan Otomatisasi Berhasil Dinonaktifkan",
      "ACTIVATION_ERROR": "Tidak dapat Mengaktifkan Otomatisasi, Harap coba lagi nanti",
      "DEACTIVATION_ERROR": "Tidak dapat Menonaktifkan Otomatisasi, Harap coba lagi nanti",
      "CONFIRMATION_LABEL": "Ya",
      "CANCEL_LABEL": "Tidak"
    },
    "ATTACHMENT": {
      "UPLOAD_ERROR": "Tidak dapat mengunggah lampiran, Harap coba lagi",
      "LABEL_IDLE": "Unggah Lampiran",
      "LABEL_UPLOADING": "Mengunggah...",
      "LABEL_UPLOADED": "Berhasil Diunggah",
      "LABEL_UPLOAD_FAILED": "Gagal Mengunggah"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "Attribute key is required",
      "FILTER_OPERATOR_REQUIRED": "Filter operator is required",
      "VALUE_REQUIRED": "Nilai dibutuhkan",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "Value must be between 1 and 998",
      "ACTION_PARAMETERS_REQUIRED": "Action parameters are required",
      "ATLEAST_ONE_CONDITION_REQUIRED": "At least one condition is required",
      "ATLEAST_ONE_ACTION_REQUIRED": "At least one action is required"
    },
    "NONE_OPTION": "Tidak ada",
    "LAST_RESPONDING_AGENT": "Last Responding Agent",
    "EVENTS": {
      "CONVERSATION_CREATED": "Percakapan Dibuat",
      "CONVERSATION_UPDATED": "Percakapan Diperbarui",
      "MESSAGE_CREATED": "Message Created",
      "CONVERSATION_RESOLVED": "Conversation Resolved",
      "CONVERSATION_OPENED": "Conversation Opened"
    },
    "ACTIONS": {
      "ASSIGN_AGENT": "Assign to Agent",
      "ASSIGN_TEAM": "Assign a Team",
      "REMOVE_ASSIGNED_AGENT": "Remove Assigned Agent",
      "REMOVE_ASSIGNED_TEAM": "Remove Assigned Team",
      "ADD_LABEL": "Add a Label",
      "REMOVE_LABEL": "Remove a Label",
      "SEND_EMAIL_TO_TEAM": "Send an Email to Team",
      "SEND_EMAIL_TRANSCRIPT": "Send an Email Transcript",
      "MUTE_CONVERSATION": "Matikan Suara Percakapan",
      "SNOOZE_CONVERSATION": "Tunda Percakapan",
      "RESOLVE_CONVERSATION": "Selesaikan Percakapan",
      "SEND_WEBHOOK_EVENT": "Send Webhook Event",
      "SEND_ATTACHMENT": "Send Attachment",
      "SEND_MESSAGE": "Send a Message",
      "ADD_PRIVATE_NOTE": "Add a Private Note",
      "CHANGE_PRIORITY": "Ubah Prioritas",
      "ADD_SLA": "Add SLA",
      "OPEN_CONVERSATION": "Buka percakapan",
      "PENDING_CONVERSATION": "Mark conversation as pending"
    },
    "MESSAGE_TYPES": {
      "INCOMING": "Incoming Message",
      "OUTGOING": "Outgoing Message"
    },
    "PRIORITY_TYPES": {
      "NONE": "Tidak ada",
      "LOW": "Rendah",
      "MEDIUM": "Sedang",
      "HIGH": "Tinggi",
      "URGENT": "Penting"
    },
    "ATTRIBUTES": {
      "MESSAGE_TYPE": "Message Type",
      "PRIVATE_NOTE": "Catatan Pribadi",
      "MESSAGE_CONTAINS": "Message Contains",
      "EMAIL": "Email",
      "INBOX": "Kotak masuk",
      "CONVERSATION_LANGUAGE": "Conversation Language",
      "PHONE_NUMBER": "Nomor Telepon",
      "STATUS": "Status",
      "BROWSER_LANGUAGE": "Bahasa Browser",
      "MAIL_SUBJECT": "Email Subject",
      "COUNTRY_NAME": "Negara",
      "COMPANY_NAME": "Perusahaan",
      "REFERER_LINK": "Referrer Link",
      "ASSIGNEE_NAME": "Assignee",
      "TEAM_NAME": "Tim",
      "PRIORITY": "Prioritas",
      "LABELS": "Label"
    }
  }
}
